import React, { useContext } from 'react'
import propTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'
import clsx from 'clsx/lite'

import MdxSuiteContext from '../../contexts/mdx-suite'
import { findActiveTrail } from '../../helpers/menu'

import MenuUl from './menu-ul'
import MenuItem from './menu-item'

export default function MenuLevel({
  rootMenuItemId,
  level = 1,
  className,
  style,
}) {
  const queryResult = useStaticQuery(graphql`
    query MenuLevelQuery {
      allContentfulContentTypeMenuItem {
        nodes {
          ...MdxSuiteMenuItem
          subitems {
            ...MdxSuiteMenuItem
            subitems {
              ...MdxSuiteMenuItem
              subitems {
                ...MdxSuiteMenuItem
                subitems {
                  ...MdxSuiteMenuItem
                }
              }
            }
          }
        }
      }
    }
  `)

  const {
    pageContext: { pageId: activePageId, locale: activeLocale },
  } = useContext(MdxSuiteContext)

  const menuRoot = queryResult.allContentfulContentTypeMenuItem.nodes.find(
    ({ sys: { locale, menuItemId } }) =>
      menuItemId === rootMenuItemId &&
      (!activeLocale || locale === activeLocale)
  )

  if (!menuRoot) {
    throw new Error(`Unable to locate root menu item ${rootMenuItemId}`)
  }

  const activeTrail = findActiveTrail({
    id: activePageId,
    subTree: [menuRoot],
  })

  const pathToTravel = activeTrail.slice(0, level)

  let currentRoot = menuRoot
  let currentLevel = 1

  pathToTravel.forEach((destination) => {
    currentLevel++

    const result = currentRoot.subitems.find(
      (item) => item.menuItemId === destination
    )

    if (result) {
      currentRoot = result
    }
  })

  if (currentLevel < level || !currentRoot.subitems) {
    return null
  }

  return (
    <MenuUl className={clsx(`level-${level}`, className)} style={style}>
      {currentRoot.subitems.map(({ ...itemData }) => (
        <MenuItem
          key={itemData.sys.menuItemId}
          activeTrail={activeTrail}
          className={`level-${level}`}
          {...itemData}
        />
      ))}
    </MenuUl>
  )
}

MenuLevel.propTypes = {
  rootMenuItemId: propTypes.string.isRequired,
  level: propTypes.number,
}
